import Model from '@/models/Model'

export default class Bank extends Model {

    resource()
    {
    return 'g_bank'
    }
}